module.exports = __webpack_public_path__ + "img/merge-1-1.c65b4940.jpg";